module.exports = __webpack_public_path__ + "fonts/SourceSansPro-Black.woff";